import { computed, ref } from 'vue'

const useRemoteFiltersSearch = () => {
  const searchText = ref('')

  const searchQueryParameters = computed(() => {
    return {
      'search': searchText.value,
    }
  })


  return {
    searchText,
    searchQueryParameters,
  }
}

export default useRemoteFiltersSearch
